import { fragSamplerSummation } from '../shaders/frag-sampler-summation.shader';
import { vertSampler } from '../shaders/vert-sampler.shader';

import { TexturePipelineBase } from './pipeline-texBase';

export class SummationTexturePipeline extends TexturePipelineBase {
  public constructor() {
    super(vertSampler, fragSamplerSummation);
  }

  public CreateTextures(imgDataList: ImageData[]): WebGLTexture[] {
    if (imgDataList.length !== 2) {
      throw new Error(`CreateTextures called without exactly 2 textures.`);
    }

    return super.CreateTextures(imgDataList);
  }

  public SetGlTextures(textures: WebGLTexture[]) {
    if (textures.length !== 2) {
      throw new Error(`SetGlTextures called without exactly 2 textures.`);
    }

    super.SetGlTextures(textures);
  }
}
